(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("CloudApp", [], factory);
	else if(typeof exports === 'object')
		exports["CloudApp"] = factory();
	else
		root["CloudApp"] = factory();
})(window, function() {
return 